import { buildSubmission } from '../../factories';
import { canonicalSubmissions } from '../../factories/seeds/entities';
import { http, HttpResponse } from 'msw';
import { Submission, SubmissionStatus } from 'interfaces/submission';
import { mockSites } from './siteMock';

const siteByID = new Map(mockSites.map((site) => [site.id, site]));

const submissionStatusMap: Record<string, SubmissionStatus> = {
  received: SubmissionStatus.received,
  cancelled: SubmissionStatus.cancelled,
  error: SubmissionStatus.error,
  generating: SubmissionStatus.generating,
  created: SubmissionStatus.created,
  pending: SubmissionStatus.pending,
  submitted: SubmissionStatus.submitted,
  submitting: SubmissionStatus.submitting,
  rejected: SubmissionStatus.rejected,
  reverted: SubmissionStatus.reverted,
};

const normalizeSubmissionStatus = (
  status: (typeof canonicalSubmissions)[number]['status']
): SubmissionStatus => {
  return submissionStatusMap[status] ?? (status as SubmissionStatus);
};

const toMockSubmission = (
  submission: (typeof canonicalSubmissions)[number]
): Submission =>
  buildSubmission<Submission>({
    ...submission,
    status: normalizeSubmissionStatus(submission.status),
    site: siteByID.get(submission.siteID) ?? null,
    claims: submission.claims ?? [],
  }) as Submission;

const baseSubmissions = canonicalSubmissions.map(toMockSubmission);

export const mockSubmissions: Submission[] = [
  ...baseSubmissions,
  buildSubmission<Submission>({
    ...baseSubmissions[0],
    status: SubmissionStatus.submitting,
  }) as Submission,
];

export const submissionMockHandlers = [
  http.get('*/resource/submission/site', ({ request }) => {
    const url = new URL(request.url).searchParams;
    const siteID = url.get('siteID');
    return HttpResponse.json(
      mockSubmissions.filter((submission) => submission.siteID === siteID)
    );
  }),
  http.get('*/resource/submission/all', () => {
    return HttpResponse.json(mockSubmissions);
  }),

  http.post('*/resource/submission/*', async () => {
    return HttpResponse.json(mockSubmissions[0]);
  }),
];
